<template>
  <IQOSModal>
      <template #title>
          {{ $t('info_modal.default_title') }}
      </template>
    
      <div class="v1-grey-3-color">
          <slot></slot>
      </div>
    

    <template #actions>
      <BaseButton
        variant="secondary"
        class="w-100"
        color="v1-grey-3"
        size="md"
        @click="onClose"
      >
        OK
      </BaseButton>
    </template>
  </IQOSModal>
</template>

<script>
export default {
  methods: {
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
